import React, { useContext } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { StorefrontContext } from 'providers/storefront';
import styles from './styles';

const TopicCard = ({ topic }) => {
  const { setFilteredResults, setSearchInput } = useContext(StorefrontContext);
  const handleClearSearch = () => {
    setFilteredResults([]);
    setSearchInput('');
  };
  return (
    <>
      <Link href={`/knowledge-hub/${topic.uid}`}>
        <a>
          <div className="topic-card" onClick={handleClearSearch}>
            <div className="topic-card-icon">
              <Image
                draggable={false}
                src={topic.data.topic_icon.url}
                alt="icon-search"
                width={32}
                height={32}
                loading="lazy"
                objectFit="contain"
              />
            </div>
            <h4 className="topic-card-title">{topic.data.topic_title}</h4>
          </div>
        </a>
      </Link>
      <style jsx>{styles}</style>
    </>
  );
};

export default TopicCard;
